import type { BillingPreference, CustomerListQuery } from '@chukua/common';
import { Tag, type TableColumnsType } from 'antd';
import { Link } from 'react-router';
import type { ListQueryControls } from '../../lib/use-list-query';
import { BILLING_PREFERENCE_LABELS } from './billing-preference-labels';
import { customerPath } from './customer-tabs';
import type { CustomerListItem } from './customers.api';

interface BuildCustomerColumnsArgs {
  list: Pick<ListQueryControls<CustomerListQuery>, 'sortOrderFor' | 'filteredValueFor'>;
}

const STATUS_FILTERS = [
  { text: 'Active', value: 'active' },
  { text: 'Inactive', value: 'inactive' },
];

/** Sorting and filtering run on the server: each column's `key` is its `sort` field or filter param in `customerListQuerySchema`. */
export function buildCustomerColumns({ list }: BuildCustomerColumnsArgs): TableColumnsType<CustomerListItem> {
  return [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      sortOrder: list.sortOrderFor('name'),
      render: (name: string, customer) => (
        <Link className="font-medium text-link hover:underline" to={customerPath(customer.id)}>
          {name}
        </Link>
      ),
    },
    { title: 'KRA PIN', dataIndex: 'kraPin', key: 'kraPin' },
    {
      title: 'Billing preference',
      dataIndex: 'billingPreference',
      key: 'billingPreference',
      render: (preference: BillingPreference) => BILLING_PREFERENCE_LABELS[preference],
    },
    {
      title: 'Status',
      key: 'status',
      filters: STATUS_FILTERS,
      filteredValue: list.filteredValueFor('status'),
      render: (_, customer) => <Tag color={customer.isActive ? 'success' : 'default'}>{customer.isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, customer) => (
        <Link className="text-sm font-medium text-link hover:underline" to={customerPath(customer.id)}>
          View
        </Link>
      ),
    },
  ];
}
